export default __webpack_public_path__ + "static/media/react.e6ecd462.pdf";